import React from "react";
import PropTypes from "prop-types";

const RegistrationSummaryHeader = ({ isVisible, summaryHeading }) =>
    isVisible ? (
        // eslint-disable-next-line tailwindcss/classnames-order
        <div className="grid grid--no-gutters">
            <div className="col">
                <div className="-margin-bottom--20">
                    <h2>{summaryHeading}</h2>
                </div>
            </div>
        </div>
    ) : null;

RegistrationSummaryHeader.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    summaryHeading: PropTypes.string.isRequired,
};

export default RegistrationSummaryHeader;
